module.exports = __webpack_public_path__ + "static/the-upside-of-stress-ff8f1771618db15540e95a1e93ccb151.jpg";